<template>
    <div>
        <v-form>
            <v-row>
                <v-col>
                    <h2>...Werde ein "digitaler Krümel"</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-alert
                        outlined
                        :type="success ? 'success' : 'warning'"
                        prominent
                        v-if="msg"
                        border="left"
                    >
                        {{ msg }}
                        <template v-if="submsg">
                            <br />{{ submsg }}
                        </template>
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-text-field
                        v-model="registrationCode"
                        outlined
                        label="Registrierungs-Code"
                        hint="Den Code erhälst du von den Krümel Admins."/>
                    <template v-if="registrationCode">
                        <v-text-field v-model="username" label="Username" hint="Min. 3 Buchstaben; wird zum Login verwendet."/>
                        <v-text-field v-model="familyname" label="Familien-Name" hint="Wird für die Zurordnung der Gerichte verwendet."/>
                        <v-text-field v-model="password" label="Passwort" type="password" hint="Min. 6 Zeichen"/>
                        <v-text-field v-model="password_repeat" label="Passwort wiederholen" type="password"/>
                    </template>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn
                        large
                        class="cyan"
                        :dark="allFieldsAreFilled"
                        :disabled="!allFieldsAreFilled"
                        @click="signUp"
                        :loading="isLoading"
                    >
                        Registrieren
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>
<script>
import AuthService from '@/services/AuthService.js';
export default {
    data() {
        return {
            username: '',
            familyname: '',
            registrationCode: '',
            password: '',
            password_repeat: '',
            msg: '',
            submsg: '',
            isLoading: false,
            success: false,
        };
    },
    computed: {
        allFieldsAreFilled() {
            return !!(this.registrationCode && this.username && this.familyname && this.password && this.password_repeat)
        }
    },
    methods: {
        async signUp() {
            this.isLoading = true
            try {
                const credentials = {
                    username: this.username,
                    familyname: this.familyname,
                    password: this.password,
                    password_repeat: this.password_repeat,
                    registrationCode: this.registrationCode,
                };
                const response = await AuthService.signUp(credentials);
                this.msg = response.msg;
                this.submsg = response.submsg;
                this.success = true
                await this.login()
                window.setTimeout(() => {
                    this.$router.push('/link-child')
                }, 3000)
            } catch (error) {
                this.msg = error.response.data.msg;
            }
            this.isLoading = false
        },
        async login() {
            const credentials = {
                username: this.username,
                password: this.password
            };
            const response = await AuthService.login(credentials);
            const token = response.token;
            const user = response.user;
            this.$store.dispatch('login', {token, user});
        }
    }
};
</script>
